interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, index) => index + 1);

  const baseButton =
    'min-w-[36px] h-9 px-3 flex items-center justify-center rounded-md text-sm transition-colors cursor-pointer whitespace-nowrap';

  return (
    <div className="flex items-center justify-center gap-2 mt-8 flex-wrap">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className={`${baseButton} border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-700 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        <i className="ri-arrow-left-s-line"></i>
        <span className="ml-1 hidden sm:inline">上一页</span>
      </button>

      {pages.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => onChange(item)}
          className={`${baseButton} ${
            item === page
              ? 'bg-primary-600 text-background-50'
              : 'border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-700'
          }`}
        >
          {item}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className={`${baseButton} border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-700 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        <span className="mr-1 hidden sm:inline">下一页</span>
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </div>
  );
}